import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { ShieldCheck } from 'lucide-react';
import { storeApi, getStoreProfile, saveStoreProfile, getStoreToken } from './storeApi';
import './store.css';

export default function StoreChangePassword() {
  const profile = getStoreProfile();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (!getStoreToken()) { nav('/store/login'); return null; }

  function submit(e) {
    e.preventDefault();
    if (next.length < 8) { toast.error('New password must be at least 8 characters'); return; }
    if (next !== confirm) { toast.error('Passwords do not match'); return; }
    setBusy(true);
    storeApi.post('/store/auth/change-password', { current_password: current, new_password: next })
      .then(() => {
        toast.success('Password updated');
        const p = profile || {};
        saveStoreProfile({ ...p, force_password_reset: false });
        nav('/store/catalogue');
      })
      .catch((e) => toast.error(e.response?.data?.detail || 'Failed to update'))
      .finally(() => setBusy(false));
  }

  return (
    <div className="store-portal min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-md store-card p-8" data-testid="change-password-page">
        <div className="text-center mb-6">
          <ShieldCheck className="w-10 h-10 text-orange-700 mx-auto mb-2" />
          <h1 className="store-headline text-2xl">Update Password</h1>
          {profile?.force_password_reset
            ? <p className="text-xs text-amber-600 mt-2">First-time login — please set a new password to continue.</p>
            : <p className="text-xs text-slate-500 mt-2">Choose a strong password (min 8 characters).</p>}
        </div>
        <form onSubmit={submit} className="space-y-3">
          <input type="password" className="store-input" placeholder="Current password"
                 value={current} onChange={(e) => setCurrent(e.target.value)}
                 data-testid="current-password" />
          <input type="password" className="store-input" placeholder="New password"
                 value={next} onChange={(e) => setNext(e.target.value)}
                 data-testid="new-password" />
          <input type="password" className="store-input" placeholder="Confirm new password"
                 value={confirm} onChange={(e) => setConfirm(e.target.value)}
                 data-testid="confirm-password" />
          <button type="submit" className="store-btn-primary w-full" disabled={busy}
                  data-testid="change-password-submit">
            {busy ? 'Updating…' : 'Update password'}
          </button>
        </form>
      </div>
    </div>
  );
}
